import './App.css';
import HomePage from './components/homepage'

function App() {
  return (
    <div className="App">
    <HomePage/>
    </div>
  );
}

export default App;
